import React, { useEffect } from 'react'
import { observer } from 'mobx-react'

import ContentLoading from 'components/ContentLoading'
import ContentError from 'components/ContentError'
import PasswordReset from 'iam/components/PasswordReset'
import CompleteRegistrationViewModel from './CompleteRegistrationViewModel'
import styles from './styles.sass'
import { RouteChildrenProps } from 'react-router'

interface Props extends RouteChildrenProps<{ token: string }> {
  vm: CompleteRegistrationViewModel
}

export default observer(function CompleteRegistration({ vm, match }: Props) {
  const token = match?.params?.token

  useEffect(() => {
    vm.activate(token)
  }, [token])

  return (
    <>
      {vm.activate.match({
        pending: () => <ContentLoading />,
        resolved: () => (
          <div className={styles.root}>
            <div className={styles.form}>
              <PasswordReset vm={vm.passwordResetVM} />
            </div>
            <div className={styles.illustration}></div>
          </div>
        ),
        rejected: (err) => (
          <div className={styles.error}>
            <ContentError error={err} />,
          </div>
        ),
      })}
    </>
  )
})
